document.addEventListener("turbolinks:load", function () {
  Array.from(document.getElementsByClassName('disable-right-click')).forEach(function (elem) {
    elem.oncontextmenu = function () { return false; };
    elem.onselectstart = function () { return false; };
    elem.onmousedown = function () { return false; };
  });
});
